import { Grid } from '@mui/material'
import { AuthLayout, Text } from 'components'
import { AuthMain, AuthWrapper } from '../SignIn'
import { Form } from './component'
import { color } from 'config/color'

interface IAuthTitle {
  title: string
}

const AuthTitle = ({ title }: IAuthTitle): JSX.Element => {
  return (
    <Text color={color.grey[900]} fontSize="24px" fontWeight="600" margin="0 0 24px">
      {title}
    </Text>
  )
}

export const ForgotPasswordReset: React.FC = () => {
  return (
    <AuthLayout isAuthPage={true}>
      <AuthWrapper isAuthPage={true}>
        <Grid container justifyContent='center' mb={7}>
          <Grid item xs={12} md={6}>
            <AuthMain isRounded={true}>
              <AuthTitle title="Reset Password" />
              <Form />
            </AuthMain>
          </Grid>
        </Grid>
      </AuthWrapper>
    </AuthLayout>
  )
}
